<template>
<div v-if="visible">
    <div class="dim">
        <div class="mangerlayer">
            <a type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="close()" style="cursor: pointer;">
                    <img src="../assets/img/modal-close.png" alt="">
                </span>
            </a>
        </div>
        <div class="modal-wrapper">
            <div class="modal-container w700">
                <div>
                    <slot name="body">
                        <div class="modal-body thr-layer2" style="width:100%;max-height:620px;overflow:auto;">
                            <!--소스-->
                            <h3 style="color:white; max-width:700px; margin:0 auto;">Mail 미리보기</h3>
                            <p class="head-desc">
                            </p>
                            <div style="background: #f8f8f8; width: 100%; letter-spacing: -1px; font-family:Malgun Gothic, 돋움, Dotum, hevetica, sans-serif; padding: 60px 0; word-break: keep-all; max-width:700px; margin: 0 auto;">
                                <div style="margin:0 auto; padding:60px 20px 0px 20px; max-width:600px; border-top:8px solid #41c2a2; background: #ffffff; width: 100%;">
                                    <div style='font-weight:bold; font-size:20px;'>{{ classinfo.companyname }} {{ classinfo.classname }} 과정</div>
                                    <div style='padding: 20px 0 40px 0; font-size:40px; text-align:left; display:block; color:#41c2a2; line-height: 60px;'>
                                        <strong style="font-size:40px;">Writing 작성과제({{ info.writing_num }}회차) </strong>안내가이드
                                    </div>
                                    <div style='font-size:16px; line-height: 30px;'>
                                        <span style='font-weight: bold; font-size:16px;'>{{ userinfo.user_kname }}</span> 학습자님, 안녕하세요.<br>
                                        {{ info.guide_content }}
                                    </div>
                                    <div style="padding: 40px 0 60px 0;">
                                        <table style="border-top: 2px solid #b3b3b3; line-height: 24px; border-spacing: 0; font-size: 14px; width: 100%;">
                                            <tr>
                                                <th style="font-weight:bold; text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; width:140px; font-size: 14px;">회차</th>
                                                <td style="text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">{{ info.writing_num }}회차</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight:bold; text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">Writing Topic</th>
                                                <td style="text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">
                                                    <a :href="info.url_topic==''?'#':info.url_topic" target="_blank" style="color: #ffffff; background: #41c2a2; text-decoration: none; padding: 3px 10px; font-size: 14px;">Topic 보러가기</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight:bold; text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">Writing 제출일</th>
                                                <td style="text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">{{ info.writing_date }} ({{ info.writing_day }})</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight:bold; text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">진행 및 제출 방식</th>
                                                <td style="text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">
                                                    Writing 과제 Guide의 내용을 확인하여<br>
                                                    - 제시된 내용에 따라 Topic을 읽고,<br>
                                                    - MS 워드에 내용을 작성하여 하기 ELP(초과학습센터) 홈페이지 내 Writing 첨삭관리에서 제출해 주시기 바랍니다.
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight:bold; text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">제출 홈페이지</th>
                                                <td style="text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">
                                                    <a :href="url" target="_blank" style="letter-spacing: 0; color: #41c2a2; font-size: 14px;">{{host}}</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight:bold; text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">로그인 계정</th>
                                                <td style="text-align: left; padding: 10px 10px; border-bottom: 1px solid #b3b3b3; font-size: 14px;">
                                                    <span style="letter-spacing: 0; font-size: 14px;">ID : {{ userinfo.user_id }}</span> <br>
                                                    PW : carrot (초기값)
                                                </td>
                                            </tr>
                                        </table>
                                        <div style="margin-top: 10px; font-size: 14px;">* 패스워드를 변경하신 분들은 변경된 패스워드를 사용하시면 됩니다.</div>
                                    </div>
                                </div>
                                <div style="background: #717171; color: #ffffff; max-width:600px; width: 100%; margin: 0 auto; text-align: center; padding: 10px 40px; font-size: 14px;">
                                    <!-- <span style="font-weight: bold; font-size: 14px;">과정문의</span> : {{ classinfo.hq_kname }} 매니저 / {{ classinfo.hq_mobile }} / <span style="letter-spacing: 0;">{{ classinfo.hq_email }}</span> -->
                                    <!-- <span style="font-weight: bold; font-size: 14px;">과정문의</span> : {{ classinfo.hq_kname }} ({{ classinfo.hq_ename }}) 매니저  / <span style="letter-spacing: 0;">{{ classinfo.hq_email }}</span> -->
                                    <span style="font-weight: bold; font-size: 14px;">과정문의</span> : {{ classinfo.hq_kname }} ({{ classinfo.hq_ename }}) 매니저 / <span style="letter-spacing: 0;">{{ hq_mail_email }}</span>
                                </div>
                            </div>
                            <!--소스-->
                        </div>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'wtguideModal',
    props: {
        visible: {
            type: Boolean,
            require: true,
            default: false
        },
        classid     : { type: String,  default: "" },
        memberseq   : { type: Number,  default: 0 },
        info        : { type: Object,  default: function(){return { title:"", guide_content:"" }} },
        hq_email        : { type: String,  default: "" },
        
    },

    data: () => ({
        is_loader : true, 
            classinfo : {}, 
            userinfo  : {},
            days_str  : [ "일", "월", "화", "수", "목", "금", "토" ],
            hq_mail_email : "",
            url:"",
            host:""
    }),
    watch: {
        visible: function (newVal) {
            if (newVal == true) {
                if(location.hostname == "stagest.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                }else if(location.hostname == "st.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }else if(location.hostname == "student.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }else if(location.hostname == "m.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }else if(location.href.includes("how")){
                    if(location.href.includes("stage")){
                        this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                    }else{
                        this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                    }
                }else{
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }
                this.initPage();

                var date = this.info.writing_date.split("-");
                var td = new Date(Number(date[0]), Number(date[1])-1, Number(date[2]));
                this.info.writing_day = this.days_str[td.getDay()];
                 this.url = location.href;
                 this.host = location.host;
                 
            } else {
                this.show  = false;
            }
        }
    },
    mounted() {
        // console.log(this.manager_email+"/");
    },

    methods: {
        close() {
            this.$emit("close", false);
            // this.visible = false;
        },
        initPage: function(){
            var me = this;
            var params = {
                idx_itm_class : me.classid, 
                tmr           : Date.now(),
                uidx: localStorage.getItem("uidx"),
            };
            if( this.info.idx_hq != "undefined" ) {
                params.idx_hq = this.info.idx_hq;
            }
            this.axios.get(this.$store.state.host + "/rest/writing/getWritingInfo_new", { params: params }).then(function (res) {
                if( res.data.info != "undefined" ){
                    me.classinfo = res.data.info;
                    me.userinfo  = res.data.users.list[0];
                    for(var i=0; i<res.data.users.count; i++){
                        var irow = res.data.users.list[i];
                        if( me.memberseq == irow["idx_member"] ){
                            me.userinfo = irow;
                        }
                    }

                    // 내용변경표시
                    me.info.guide_content = me.info.guide_content.replace("[회사명]", me.classinfo.companyname);
                    me.info.guide_content = me.info.guide_content.replace("[클래스명]", me.classinfo.classname);
                    me.info.guide_content = me.info.guide_content.replace("[HQ매니저명]", me.classinfo.hq_ename);
                    me.info.guide_content = me.info.guide_content.replace("[학습자명]", me.userinfo.user_kname);
                    // console.log(me.classinfo);

                    me.hq_mail_email = me.classinfo.hq_email;
                } 

                me.is_loader = false;
            });
            this.hq_mail_email = this.hq_email;
        },
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.dim {
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    box-sizing: border-box;
    z-index: 999;

    .mangerlayer {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 20px #0000001A;
        border-radius: 20px;
        width: 90%;
        margin: 0 auto;
        max-width: 700px;
        margin-top: 60px;
        position: relative;

        .modal-default-button2 {
            position: absolute;
            top: -440px;
            right: 0;
            width: 30px;
            height: 30px;
            background-color: transparent;
            border: 0;
            outline: none;
            color: #fff;

            &:focus {
                outline: none;
            }
        }

        .modal-wrapper {
            display: table-cell;
            vertical-align: middle;
        }

        .modal-container {
            position: relative;
            // width: 700px;
            margin: 0px auto;
            background-color: white;
            box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
            transition: all .3s ease;
            font-family: Helvetica, Arial, sans-serif;
        }

        .modal-container-sms {
            position: relative;
            // width: 700px;
            margin: 0px auto;
            background-color: white;
            box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
            transition: all .3s ease;
            font-family: Helvetica, Arial, sans-serif;
            border-radius: 20px;
        }

        /* modal header css */
        .modal-header {
            display: block;
            margin-top: 0;
            padding: 20px;
            // background-color: $col_default;
            border-radius: 0;

            .title {
                color: white;
                font-size: 18px;
                font-weight: bold;
            }

            .desc {
                color: white;
                font-size: 13px;
                font-weight: normal;
                padding-top: 10px;
            }
        }

        /* modal body css */
        .modal-body {
            margin: 0;
            padding: 20px;

            .title {
                color: black;
                font-size: 20px;
                font-weight: bold;
            }

            .modal-tbl {
                width: 100%;
                font-size: 12px;
                // border-top: 1px solid $col_light;
                text-align: center;
            }

            .modal-tbl th {
                padding: 10px;
                margin: -1px;
                // border: 1px solid $col_light;
                line-height: 140%;
                background-color: #dcdcdc;

                &.primary {
                    color: white;
                    // background-color: $col_default;
                }

                &.back {
                    background-color: #f4f4f4;
                }
            }

            .modal-tbl td {
                padding: 10px;
                margin: -1px;
                // border: 1px solid $col_light;
                line-height: 140%;

                &.primary {
                    color: white;
                    // background-color: $col_default;
                }

                &.mark {
                    font-size: 16px;
                    // color: $col_default;
                    background-color: white;
                }
            }
        }

        /* modal footer css */
        .modal-footer {
            display: block;
            padding: 0 20px 20px;
            border: 0;

            .title {
                font-size: 14px;
                font-weight: bold;
                line-height: 30px;
            }

            .desc {
                font-size: 12px;
                font-weight: normal;
                line-height: 140%;
            }
        }

        .modal-default-button {
            position: absolute;
            top: -440px;
            right: 0;
            width: 30px;
            height: 30px;
            background-color: transparent;
            border: 0;
            outline: none;
            color: #fff;

            &:focus {
                outline: none;
            }
        }

        .modal-enter {
            opacity: 0;
        }

        .modal-leave-active {
            opacity: 0;
        }

        .modal-enter .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }

        .modal-chat {
            /* talk 현황 control */
            width: 500px;

            .talk-mems {
                .talk-mem {
                    display: inline-block;
                    padding: 10px;
                    font-size: 14px;
                    cursor: pointer;

                    &:hover {
                        // color: $col_default;
                    }
                }
            }

            .talk-box {
                height: 400px;
                overflow: hidden;
                overflow-y: auto;

                .talk-item {
                    .bubble-txt {
                        min-height: 36px;
                        padding: 14px 12px 4px 32px;
                        word-wrap: break-word;
                        font-size: 14px;
                        color: black;
                        line-height: 18px;
                    }

                    .left-area {
                        text-align: left;
                        width: 100%;
                        // margin: 0 0 20px 0;
                        font-size: 14px;
                        color: #666;
                        line-height: 16px;

                        .bubble-top {
                            padding-left: 20px;
                        }

                        .bubble {
                            width: 271px;
                            background: url('/resource/itmhq/img/bubble1_top.png') no-repeat left top;
                        }

                        .bubble-bottom {
                            height: 10px;
                            background: url('/resource/itmhq/img/bubble1_bot.png') no-repeat left top;
                        }
                    }

                    .right-area {
                        text-align: right;
                        width: 100%;
                        // margin: 0 0 20px 0;
                        font-size: 14px;
                        color: #666;
                        line-height: 16px;

                        .bubble-top {
                            padding-right: 20px;
                        }

                        .bubble-txt {
                            padding: 14px 32px 4px 12px;
                            text-align: right;
                        }

                        .bubble {
                            float: right;
                            width: 271px;
                            // background: url('/resource/itmhq/img/bubble2_top.png') no-repeat left top;
                        }

                        .bubble-bottom {
                            height: 10px;
                            // background: url('/resource/itmhq/img/bubble2_bot.png') no-repeat left top;
                        }
                    }

                    .talk-writer {
                        font-size: 14px;
                        // color: $col_default;
                    }

                    .talk-wdate {
                        font-size: 12px;
                        font-weight: normal;
                        // color: $col_gray;
                    }
                }
            }

            .talk-input-box {
                height: 100px;
                // background-color: $col_light;
                padding-top: 10px;
                margin: 0 -20px -20px;

                .message {
                    float: left;
                    width: 370px;
                    height: 80px;
                    resize: none;
                    padding: 10px;
                    margin-left: 20px;
                }

                .btn-chat {
                    float: right;
                    width: 89px;
                    height: 80px;
                    // background-color: $col_default;
                    color: white;
                    // border: 1px solid $col_light;
                    margin-right: 20px;
                }
            }
        }
    }

}
</style>
